import {Col, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import React, {useEffect, useState} from 'react';
import {getFormattedNumber, getFormattedPercentage} from '../utils/NumberUtils';
import {PlanVO} from '../api';

interface ListProps {
    data: PlanVO[];
    skutecnost: boolean;
}

export const List: React.FC<ListProps> = ({data, skutecnost}) => {
    const [plans, setPlans] = useState<PlanVO[]>([]);
    const [sortCol, setSortCol] = useState<number>();
    const [asc, setAsc] = useState(false);
    const [sum, setSum] = useState<number>(0);

    useEffect(() => {
        setPlans([...data]);
        let s = 0;
        data.forEach(item => {
            if (skutecnost) {
                s += Math.abs(item.skutecnnost ? item.skutecnnost : 0);
            } else {
                s += Math.abs(item.upravenyRozpocet ? item.upravenyRozpocet : 0);
            }
        });
        setSum(s);
    }, [skutecnost, data]);

    const sort = (colIndex: number) => {
        setSortCol(colIndex);
        setAsc(!asc);
        const temp = [...plans];
        switch (colIndex) {
            case 0:
                temp.sort((a, b) => {
                    if (!a.nazevAkce || !b.nazevAkce) {
                        return 0;
                    }
                    const nameA = asc ? a.nazevAkce.toUpperCase() : b.nazevAkce.toUpperCase();
                    const nameB = asc ? b.nazevAkce.toUpperCase() : a.nazevAkce.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });
                break;
            case 1:
            case 2:
                temp.sort((a, b) => {
                    if (!a.castka || !b.castka) {
                        return 0;
                    }
                    return asc ? a.castka - b.castka : b.castka - a.castka;
                });
                break;
        }
        setPlans(temp);
    };

    let icon = null;
    if (asc) {
        icon = <FontAwesomeIcon icon={faCaretDown} style={{marginLeft: 8}} />;
    } else {
        icon = <FontAwesomeIcon icon={faCaretUp} style={{marginLeft: 8}} />;
    }

    return (
        <div>
            <Row>
                <Col className="class-col smaller-text">Částky uváděné v tis. Kč</Col>
            </Row>
            <Row className="main-container class-row-font touchable" style={{backgroundColor: 'rgb(65,118,204)'}}>
                <Col xs={8} style={{color: 'white'}} onClick={() => sort(0)}>
                    NÁZEV
                    {sortCol === 0 ? icon : ''}
                </Col>
                <Col className="class-col" style={{color: 'white'}} onClick={() => sort(1)}>
                    {skutecnost ? 'SKUTEČNOST' : 'UPRAV. ROZPOČET'}
                    {sortCol === 1 ? icon : ''}
                </Col>
                <Col className="class-col" style={{color: 'white'}} onClick={() => sort(2)}>
                    PODÍL
                    {sortCol === 2 ? icon : ''}
                </Col>
            </Row>
            {plans.map((item, index) => {
                let backColor = index % 2 == 0 ? 'rgba(201,213,229,0.07)' : '#FFFFFF';
                return (
                    <Row key={item.idPlan} className="main-container class-row-font" style={{backgroundColor: backColor}}>
                        <Col xs={8}>{item.nazevAkce}</Col>
                        <Col md="auto" className="class-col">
                            {getFormattedNumber(item.castka)}
                        </Col>
                        <Col md="auto" className="class-col">
                            {getFormattedPercentage(item.procento ? item.procento : 0)}%
                        </Col>
                    </Row>
                );
            })}
        </div>
    );
};
